export type FlowOpenRequestController = {
	/** Releases admission for a new call without cancelling the current request. */
	clear: () => void;
	run: (start: () => Promise<void>) => Promise<void>;
};

/**
 * Coalesces one pending FlowRun.open call without owning transport or flow
 * lifecycle state.
 */
export const createFlowOpenRequestController =
	(): FlowOpenRequestController => {
		let pendingRequest: Promise<void> | null = null;

		const run: FlowOpenRequestController["run"] = (start) => {
			if (pendingRequest) {
				return pendingRequest;
			}

			let resolvePendingRequest!: () => void;
			let rejectPendingRequest!: (error: unknown) => void;
			const sharedRequest = new Promise<void>((resolve, reject) => {
				resolvePendingRequest = resolve;
				rejectPendingRequest = reject;
			});
			pendingRequest = sharedRequest;

			let request: Promise<void>;
			try {
				request = start();
			} catch (error) {
				request = Promise.reject(error);
			}

			void request.then(
				() => {
					if (pendingRequest === sharedRequest) {
						pendingRequest = null;
					}
					resolvePendingRequest();
				},
				(error) => {
					if (pendingRequest === sharedRequest) {
						pendingRequest = null;
					}
					rejectPendingRequest(error);
				},
			);
			return sharedRequest;
		};

		return {
			clear: () => {
				pendingRequest = null;
			},
			run,
		};
	};
